import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { API, graphqlOperation } from "aws-amplify";
import {
  getCodeTranslation,
  getCompany,
  getCompanyCodeTranslation,
  listPlaceOfSupply,
  listUserCompanies,
} from "../../graphql";
import { PURGE } from "redux-persist";
import { showErrorSnackbar } from "../../components/snackBar/snakbar";

export const fetchTDSList = createAsyncThunk("TDSList", async () => {
  const TDSList = await API.graphql(
    graphqlOperation(getCompanyCodeTranslation, { codetype: "1" })
  );
  console.log(TDSList, "TDSList");
  if (TDSList?.data) return TDSList?.data;
});
const INITIAL_STATE = {
  TDSList: [],
  render: true,
  Loaded: false,
  loading: false,
};
const TDSList = createSlice({
  name: "tds",
  initialState: INITIAL_STATE,
  reducers: {
    setTDSList(state, action) {
      state.TDSList = action.payload;
    },
  },

  extraReducers: (builder) => {
    builder

      .addCase(fetchTDSList.pending, (state) => {
        state.Loaded = false;
      })
      .addCase(fetchTDSList.fulfilled, (state, action) => {
        if (action?.payload) {
          return {
            ...state,
            TDSList: action.payload,
            Loaded: true,
          };
        } else {
          state.Loaded = true;
        }
      })
      .addCase(fetchTDSList.rejected, (state) => {
        state.Loaded = false;
        showErrorSnackbar("Network Error !");
      })
      .addCase(PURGE, () => INITIAL_STATE);
  },
});

export const { setTDSList } = TDSList.actions;
export default TDSList.reducer;
